import { createFileRoute, Outlet } from '@tanstack/react-router'
import BottomBar from '@/components/features/paytm/bottom-nav-bar'
import { useStore } from '@/store'
import { useShallow } from 'zustand/shallow'
import Login from '@/components/features/login'
import { ProfileMenu } from '@/components/features/profile-menu'
import { useEffect } from 'react'
import { useNavigate } from '@tanstack/react-router'
import { is_shikhar_account } from '@/lib/utils'

export const Route = createFileRoute('/shikhar')({
  component: RouteComponent,
})

function RouteComponent() {
  const { setPaytmTab, paytmTab, token, phoneNumber, accountId, loggedIn } = useStore(useShallow(state => ({
    paytmTab: state.paytmTab,
    setPaytmTab: state.setPaytmTab,
    token: state.token,
    phoneNumber: state.phoneNumber,
    accountId: state.selectedAccount.id,
    loggedIn: state.loggedIn,
  })))
  const navigate = useNavigate()
  const isShikhar = is_shikhar_account(accountId)

  useEffect(() => {
    if (loggedIn && !isShikhar) {
      navigate({ to: '/orders' })
    }
  }, [loggedIn, isShikhar, navigate])

  if (loggedIn) {
    return <div className='w-full brand-shikhar'>
      <div className="fixed top-3 right-3 z-40">
        <ProfileMenu />
      </div>
      <Outlet />
      <BottomBar selectedTab={paytmTab}
        selectTab={val => setPaytmTab(val)}
        token={token}
        phoneNumber={phoneNumber}
        accountId={accountId}
        basePath="/shikhar"
      />
    </div>
  } else {
    return <Login />
  }
}
